<template>
  <div id="app">
    <!-- <AutoPlay></AutoPlay> -->
    <iframe class="canvas" style="opacity: .2" src="/static/index.html" frameborder="0" />
    <router-view />
  </div>
</template>

<script>

import AutoPlay from '@/components/common/AutoPlay';

export default {
  name: 'App',
  components: {
    AutoPlay,
  },
  methods: {
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: 100vh;
  min-height: 800px;
  /*overflow: hidden;*/
}

.canvas {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 99%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue